module.exports = __webpack_public_path__ + "static/media/27.151c70ff.jpg";